import { useRef } from "react";
import { Avatar } from "antd";
import { EstagioArtistaProps } from "./NewEstagioArtista";
import { useSelector } from "react-redux";
import { getCapitalizedLang } from "shared/helpers/capitalized-lang";
import { Trans, useTranslation } from "react-i18next";
import { ReactComponent as IconCheck } from "shared/assets/images/icon-check.svg";
import { Slider } from "shared/components";
import CardMinhaJornada from "./cards/CardMinhaCarreira";
import CardPlanoEstrategico from "./cards/CardPlanoEstrategico";
import CardDiagnosticoCompleto from "./cards/CardDiagnosticoCompleto";
import { Link, useHistory } from "react-router-dom";
import { formatNoSignObject, signByCurrency } from "shared/helpers/BRLFormat";
import { isMobile } from "react-device-detect";
import { ReactComponent as EstrelaIcon } from "shared/assets/images/icon-estrela.svg";
import { ReactComponent as DistroIcon } from "shared/assets/images/icon-distribution-side-menu.svg";
import { ReactComponent as SpotifyIcon } from "shared/assets/images/icon-spotify.svg";
import { ReactComponent as AppleMusicIcon } from "shared/assets/images/icon-apple-music.svg";
import { ReactComponent as AmazonMusicIcon } from "shared/assets/images/icon-amazon-music.svg";
import { ReactComponent as YoutubeIcon } from "shared/assets/images/icon-youtube.svg";
import { ReactComponent as DeezerIcon } from "shared/assets/images/icon-deezer.svg";
import { ReactComponent as TidalIcon } from "shared/assets/images/icon-tidal.svg";
import { ReactComponent as SpikeArrow } from "shared/assets/images/spike-arrow.svg";
import CardAdiantamento from "./cards/CardAdiantamento";
import CardDistro from "./cards/CardDistro";

import { CashAdvanceAvailableEnum } from "shared/enums/CashAdvanceAvailable";
import GenreTagList from "shared/components/genre-tag-list";
import CardCTAHenriqueJuliano from "./campanhas-especiais/ctas/CardCTAHenriqueJuliano";
import { canAskAdvance } from "explorer/reducers/adiantamentos";
import ButtonRemakeQuiz from "shared/components/button-remake-quiz/ButtonRemakeQuiz";
import { isEnableFullDiagnostic } from "shared/helpers/full-diagnostic-helpers";
import CardCTAKamillaFialho from "./campanhas-especiais/ctas/CardCTAKamillaFiallio";
import CardCTAAnnoDomini from "./campanhas-especiais/ctas/CardCTAAnnoDomini";
import { ArtistState } from "explorer/reducers/artistas";
import { DistributionStatusEnum } from "shared/enums/DistributionStatusEnum";
import { formatDateByLanguage } from "shared/helpers/date-format-helpers";
import { UserState } from "explorer/reducers/users";

const DistroContent = () => {
  const { t } = useTranslation();
  const { userArtist } = useSelector((state: ArtistState) => state.artists);

  // if (
  //   userArtist?.distribution?.status === DistributionStatusEnum.Signed &&
  //   !distroToken
  // ) {
  //   return (
  //     <div className="distro-content">
  //       <h3 className="heading-h3">{t("pages.EstagioArtista.tokenError")}</h3>
  //       <p className="body-regular">
  //         {t("pages.EstagioArtista.tokenErrorTexto")}
  //       </p>
  //     </div>
  //   );
  // }

  return (
    <>
      {userArtist?.distribution?.status === DistributionStatusEnum.Signed ? (
        <div className="distro-content">
          <h3 className="heading-h3">
            {t("pages.EstagioArtista.distribuaAgora")}
          </h3>
          <p className="body-regular">
            {t("pages.EstagioArtista.distroLiberadoTexto")}
          </p>
        </div>
      ) : (
        <ul>
          <li className="circle-checkmark azul">
            {t("pages.EstagioArtista.distroAcessoAoLabels")}
          </li>
          <li className="circle-checkmark azul">
            {t("pages.EstagioArtista.distroIsencaoTaxaUpload")}
          </li>
          <li className="circle-checkmark azul">
            {t("pages.EstagioArtista.distrosMigracaoCatalogo")}
          </li>
        </ul>
      )}
    </>
  );
};

const EstagioArtistsInicio: React.FC<EstagioArtistaProps> = () => {
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const { userArtist } = useSelector((state: ArtistState) => state.artists);
  const { countryByKeys } = useSelector((state: any) => state.countries);
  const { loggedUser } = useSelector((state: UserState) => state.users);
  const { cashAdvanceAvailable } = useSelector((state: any) => state.advances);
  const aprofundeDiagnostico = useRef<HTMLDivElement>(null);
  const advanceAmount = `${signByCurrency(
    userArtist?.cashAdvanceEstimated?.currency,
  )} ${formatNoSignObject({
    currency: userArtist?.cashAdvanceEstimated?.currency,
    amount:
      (userArtist?.cashAdvanceEstimated?.amount ?? 0) /
      (userArtist?.cashAdvanceEstimated?.trancheFactor ?? 1),
  })}`;
  const advanceAmountTranche = `${signByCurrency(
    userArtist?.cashAdvanceEstimated?.currency,
  )} ${formatNoSignObject(userArtist?.cashAdvanceEstimated)}`;

  const showCTADistroStrm = () =>
    userArtist?.distribution?.available ||
    userArtist?.distribution?.status === DistributionStatusEnum.Pending ||
    userArtist?.distribution?.status === DistributionStatusEnum.Signed;

  let { titulo, explicacao, posicao, principalObjetivo } = t(
    `pages.EstagioArtista.estagio.${userArtist?.stage || 0}`,
  ) as any;

  const goRouteScrollTop = (route: string) => {
    history.push(route);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const onOkModalDistro = async () => {
    history.push("/distribuicao");
  };

  const getCountryByKey = (key?: string) => {
    if (key && countryByKeys) {
      const country = countryByKeys[key];
      if (country) {
        const lang = getCapitalizedLang(i18n);
        return country[`description${lang}`];
      }
    }
    return key;
  };

  const getEstagioPercentage = () => {
    if (userArtist?.stage === 10) return 100;
    return (
      (userArtist?.stagePercentual || 1) / 10 +
      ((userArtist?.stage || 1) - 1) * (100 / (10 - 1))
    );
  };

  const isEnglish = i18n.language.startsWith("en");

  function getCurrentDateTime() {
    const currentDate = new Date(userArtist?.updatedOn ?? 0);

    const days = currentDate.getDate().toString().padStart(2, "0");
    const hours = currentDate.getHours().toString().padStart(2, "0");
    const minutes = currentDate.getMinutes().toString().padStart(2, "0");
    const seconds = currentDate.getSeconds().toString().padStart(2, "0");
    const month = (currentDate.getMonth() + 1).toString().padStart(2, "0");
    const year = currentDate.getFullYear().toString().slice(-2);

    return {
      days,
      hours,
      minutes,
      seconds,
      month,
      year,

      // Formatação condicional baseada no idioma inglês
      displayDay: isEnglish ? month : days,
      displayMonth: isEnglish ? days : month,
      displayYear: year,
    };
  }

  // Atualizar a desestruturação
  const { displayDay, displayMonth, displayYear } = getCurrentDateTime();

  const mensagemSemAdiantamento = () => {
    if (
      cashAdvanceAvailable === CashAdvanceAvailableEnum.NotAvailable ||
      cashAdvanceAvailable === CashAdvanceAvailableEnum.NotFound
    )
      return t("pages.Adiantamentos.naoCumpreRequisitosMensagemSimples", {
        currency: signByCurrency(userArtist?.cashAdvanceEstimated?.currency),
      });

    if (cashAdvanceAvailable === CashAdvanceAvailableEnum.NeedRetry)
      return t("pages.Adiantamentos.tentarNovamenteEmbreve");

    // if (cashAdvanceAvailable === CashAdvanceAvailableEnum.NotFound)
    //   return t("pages.Adiantamentos.spotifyNaoEncontrado");
  };

  const CardCTAADiantamento = () => {
    if (
      canAskAdvance(cashAdvanceAvailable) ||
      loggedUser?.isCashAdvanceAvailable
    )
      return (
        <div className="caixa-adiantamento padding" style={{ maxWidth: 600 }}>
          <div className="background" />
          <div className="container-linhas">
            <div className="linha linha-paragrafo">
              <p className="branco">
                <Trans
                  i18nKey="pages.Adiantamentos.adianteReceitas"
                  components={{ span: <span className="cor-destaque" /> }}
                />
              </p>
            </div>
            <div className="linha linha-paragrafo">
              <p>{t("pages.Adiantamentos.disponivel")}</p>
              <p className="valor">
                <b>
                  {(userArtist?.cashAdvanceEstimated?.trancheFactor ?? 0) > 1 &&
                    `${userArtist?.cashAdvanceEstimated?.trancheFactor}x `}
                  {advanceAmount}
                </b>
                {(userArtist?.cashAdvanceEstimated?.trancheFactor ?? 0) > 1 && (
                  <> ({advanceAmountTranche})</>
                )}
              </p>
              {(userArtist?.cashAdvanceEstimated?.trancheFactor ?? 0) > 1 && (
                <span>
                  {t("pages.Adiantamentos.recebeParcela", {
                    amount: advanceAmount,
                  })}
                </span>
              )}
            </div>
            {userArtist.cashAdvanceEstimated?.calculatedOn && (
              <div className="linha linha-paragrafo">
                <p>
                  {t("pages.Adiantamentos.disclaimerCalculadoEm", {
                    data: formatDateByLanguage(
                      userArtist.cashAdvanceEstimated.calculatedOn,
                      i18n.language,
                    ),
                    interpolation: { escapeValue: false },
                  })}
                </p>
                <p>{t("pages.Adiantamentos.disclaimerValidade")}</p>
              </div>
            )}
            <div className={`linha actions`}>
              <button
                className="botao-roxo botao-adiantamento-desktop"
                onClick={() => goRouteScrollTop("/adiantamentos")}
              >
                {t("pages.Adiantamentos.solicitarAgora")}
              </button>
            </div>
            {!userArtist.cashAdvanceEstimated?.calculatedOn && (
              <div className={`linha disclaimer`}>
                <p className="roxo">
                  {t("pages.Adiantamentos.valoresSujeitoAlteracoes")}
                </p>
              </div>
            )}
          </div>
        </div>
      );

    return (
      <div className="caixa-adiantamento padding" style={{ maxWidth: 600 }}>
        <div className="background" />
        <div className="container-linhas">
          <div className="linha">
            <p className="branco">
              {t("pages.EstagioArtista.adiantamentoNaoLiberadoTitulo")}
            </p>
          </div>
          <div className="linha">
            <p className="roxo">
              <Trans i18nKey={mensagemSemAdiantamento()} />
            </p>
          </div>
          <div className={`linha actions`}>
            <button
              className="botao-roxo"
              onClick={() => goRouteScrollTop("/adiantamentos")}
            >
              {t("pages.EstagioArtista.saibaMais")}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const CardCTADistroMobile = () => (
    <div className="caixa-distro">
      <span className="branco">
        <DistroIcon /> {t("pages.EstagioArtista.distoLiberadoTitulo")}
      </span>
      <div className="botoes-icones">
        <div className="icones">
          <AmazonMusicIcon />
          <SpotifyIcon />
          <YoutubeIcon />
          <TidalIcon />
          <AppleMusicIcon />
          <DeezerIcon />
        </div>
      </div>
      <div className="content-text">
        <SpikeArrow
          style={{
            position: "absolute",
            opacity: 0.5,
            top: -116,
            right: -29,
            width: "100%",
          }}
        />
        <DistroContent />
        <div className="background" />
      </div>
      {(userArtist?.distribution?.status !== DistributionStatusEnum.Signed ||
        userArtist?.distribution?.status === DistributionStatusEnum.Signed) && (
        <div
          style={{
            margin: "24px 60px",
            display: "flex",
            flexDirection: "column",
            gap: 12,
          }}
        >
          <button className="botao-roxo" onClick={onOkModalDistro}>
            {t("pages.EstagioArtista.distribuaComStrm")}
          </button>
        </div>
      )}
    </div>
  );

  const CardCTADistro = () => (
    <div className="caixa-distro" style={{ display: "flex" }}>
      <div
        style={{ display: "flex", flexDirection: "column", gap: 20, flex: 1 }}
      >
        <span className="branco">
          <DistroIcon /> {t("pages.EstagioArtista.distoLiberadoTitulo")}
        </span>
        <div className="content-text">
          <DistroContent />
          <div className="background" />
        </div>
        {(userArtist?.distribution?.status !== DistributionStatusEnum.Signed ||
          userArtist?.distribution?.status ===
            DistributionStatusEnum.Signed) && (
          <div
            style={{
              display: "flex",
              gap: 12,
            }}
          >
            <button className="botao-roxo" onClick={onOkModalDistro}>
              {t("pages.EstagioArtista.distribuaComStrm")}
            </button>
          </div>
        )}
      </div>
      <div style={{ flex: 1.2 }}>
        <div
          className="botoes-icones"
          style={{ display: "flex", justifyContent: "center", marginTop: 40 }}
        >
          <SpikeArrow style={{ position: "absolute", opacity: 0.5 }} />
          <div className="icones web">
            <AmazonMusicIcon />
            <SpotifyIcon />
            <YoutubeIcon />
            <TidalIcon />
            <AppleMusicIcon />
            <DeezerIcon />
          </div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="inicio">
      <div className="intro">
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div className="dados-artista">
            <Avatar src={userArtist?.profileImage} size={isMobile ? 85 : 180} />
            <div className="informacoes">
              <h1>{userArtist?.name}</h1>
              <span className="pais">
                {getCountryByKey(userArtist?.country)}
              </span>
              <span className="genero">{t(`pages.EstagioArtista.genero`)}</span>
              <GenreTagList genreList={userArtist.genresStrm} />
            </div>
          </div>
          {!isMobile && <CardCTAADiantamento />}
        </div>
        <div className="estagio-inicio">
          <span className="label">
            {t(`pages.EstagioArtista.estagioArtista`)}
          </span>
          <div className="box-estagio">
            <div>
              <div className="numero-titulo">
                <span className="numero">{userArtist?.stage}</span>
                <span className="titulo">{titulo}</span>
              </div>
            </div>
          </div>
          <div style={{ margin: "32px 12px" }}>
            <Slider
              marks={Array.from(
                { length: 10 },
                (_, i) => i * (100 / (10 - 1)),
              ).reduce((acc, cur) => ({ ...acc, [cur]: " " }), {})}
              value={getEstagioPercentage()}
              handleRender={() => (
                <>
                  <div
                    className="custom-handle rc-slider-handle"
                    style={{
                      left: `${getEstagioPercentage()}%`,
                      color: "black",
                      transform: "translateX(-50%)",
                    }}
                  >
                    {userArtist?.stage}
                    {(userArtist?.stage || 1) < 10 && (
                      <span
                        className="porcentagem"
                        style={{
                          left: userArtist?.stage === 9 ? 0 : undefined,
                        }}
                      >{`${userArtist?.stagePercentual?.toFixed(0)}%`}</span>
                    )}
                  </div>
                </>
              )}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              justifyContent: "space-between",
            }}
          >
            <div style={{ flex: "1 1" }}>
              <p className="strong-roxo explicacao">
                <Trans i18nKey={explicacao} />
              </p>
              {isEnableFullDiagnostic(userArtist) && (
                <div style={{ display: "flex", gap: "1rem" }}>
                  {!isMobile && (
                    <>
                      <Link to="/metas">
                        <button className="botao-branco">
                          {t("pages.Metas.btnMetasProximoEstagio")}
                        </button>
                      </Link>
                      <button
                        className="botao-borda-roxa"
                        style={{ alignSelf: "center" }}
                        onClick={() => goRouteScrollTop("/diagnosticos")}
                      >
                        <EstrelaIcon style={{ marginBottom: 4 }} />
                        {t("pages.EstagioArtista.facaDiagnosticoCompleto")}
                      </button>
                    </>
                  )}
                </div>
              )}
            </div>
            {isMobile && (
              <div>
                <Link to="/metas">
                  <button className="botao-branco">
                    {t("pages.Metas.btnMetasProximoEstagio")}
                  </button>
                </Link>
              </div>
            )}
            <div className="atualizacao">
              <div className="content">
                <span>{t("pages.EstagioArtista.dadosAtualizados")}</span>

                <div className="proxima-atualizacao">
                  <div>
                    <div className="caixa">{displayDay}</div>
                    <div className="label">
                      {t(
                        isEnglish
                          ? "pages.EstagioArtista.mes"
                          : "pages.EstagioArtista.dia",
                      )}
                    </div>
                  </div>
                  <div>
                    <div className="caixa" style={{ width: 10 }}>
                      /
                    </div>
                    <div className="label"></div>
                  </div>
                  <div>
                    <div className="caixa">{displayMonth}</div>
                    <div className="label">
                      {t(
                        isEnglish
                          ? "pages.EstagioArtista.dia"
                          : "pages.EstagioArtista.mes",
                      )}
                    </div>
                  </div>
                  <div>
                    <div className="caixa" style={{ width: 10 }}>
                      /
                    </div>
                    <div className="label"></div>
                  </div>
                  <div>
                    <div className="caixa">{displayYear}</div>
                    <div className="label">{t("pages.EstagioArtista.ano")}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {!isMobile && <span className="divider" />}

        {isMobile && <CardCTAADiantamento />}

        <div className="estagio-atual">
          <span className="label">
            {t("pages.EstagioArtista.estagioAtual")}
          </span>
          <div className="list">
            {posicao?.map((item: any, index: number) => (
              <div key={`${index}_ATUAL`} className="item">
                <IconCheck />
                <span style={{ display: "flex", flex: 1 }}>{item}</span>
              </div>
            ))}
          </div>
          {isMobile && isEnableFullDiagnostic(userArtist) && (
            <button
              className="botao-roxo"
              style={{ alignSelf: "center" }}
              onClick={() => goRouteScrollTop("/diagnosticos")}
            >
              <EstrelaIcon style={{ marginBottom: 4 }} />
              {t("pages.EstagioArtista.facaDiagnosticoCompleto")}
            </button>
          )}
        </div>
        {!isMobile && (
          <>
            <CardCTAHenriqueJuliano />
            <CardCTAKamillaFialho />
          </>
        )}
        {!isMobile && showCTADistroStrm() && <CardCTADistro />}
      </div>
      <div className="principal-objetivo">
        <div className="background">
          <div className="conteudo">
            <h1 style={{ lineHeight: 1 }}>
              {t("pages.EstagioArtista.principalObjetivo")}
            </h1>
            <p>
              <Trans i18nKey={principalObjetivo} />
            </p>
            <button
              className="botao-branco"
              onClick={() => {
                aprofundeDiagnostico.current?.scrollIntoView({
                  behavior: "smooth",
                });
                if (isMobile)
                  setTimeout(() => {
                    window.scrollBy({ top: -50, left: 0, behavior: "smooth" });
                  }, 600);
              }}
            >
              {t("pages.EstagioArtista.saibaMais")}
            </button>
          </div>
        </div>
      </div>
      {isMobile && (
        <div className="aprofunde-diagnostico">
          <CardCTAHenriqueJuliano mobile />
          <CardCTAKamillaFialho mobile />
          <CardCTAAnnoDomini mobile />
        </div>
      )}
      {isMobile && showCTADistroStrm() && (
        <div className="aprofunde-diagnostico">
          <CardCTADistroMobile />
        </div>
      )}
      <div className="aprofunde-diagnostico" ref={aprofundeDiagnostico}>
        <h1 className="title-aprofunde-diagnostico">
          {t("pages.EstagioArtista.aprofundeDiagnostico")}
        </h1>
        <div className="cards">
          <CardMinhaJornada />
          <CardPlanoEstrategico />
          <CardDistro />
          <CardAdiantamento />
          {isEnableFullDiagnostic(userArtist) && <CardDiagnosticoCompleto />}
        </div>
        {isMobile && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 32,
            }}
          >
            <ButtonRemakeQuiz />
          </div>
        )}
      </div>
    </div>
  );
};

export default EstagioArtistsInicio;
